<article class="shift-otp-align">
  <div class="w-100">
    <div class="shift-help"> <a href="https://shift.in" target="_blank"> <img class="mb-5" src="/assets/images/shift.png"/></a>
      <h1 class="pt-2">{{titleMessage}}</h1>
    </div><br>
    <div class="mb-2 mt-2">Thank You. Your Account has been created in Shift</div>
    <div class="mb-2">Please click here to create your password <br> <a class="link" routerLink="/access/resetPassword/{{token}}">Login.</a></div>
  </div>
</article>
